import React, { Component } from "react";
import { connect } from "react-redux";
import { Table } from "antd";
import { usrRole } from "../../utils/dataUtil";
import {
    req_list_gam_freshWorkPercentage,
} from "../../api";
class FreshWorkPercentage extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    searchField: "NONE",
    searchValue: "",
    loading: false,
    userLevel: "NORMAL",
    data: [],
  };

  componentWillMount() {
    this.api_rows_list();
  }

  /////////////////////
  api_rows_list = async () => {
    const { token, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_gam_freshWorkPercentage(
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items });
    } else {
      this.setState({ data: [] });
    }
  };

  /////////////////////
  handle_data_refresh = () => {
    this.api_rows_list();
    //console.log("refresh");
  };

  /////////////////////
  render() {
    const { data, loading } =
      this.state;
    const columns = [
      {
        title: "學年度",
        dataIndex: "GraduateYear",
        align: "center",
        width: 60,
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 900 },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學制",
        dataIndex: "EducationalSystem",
        align: "center",
        width: 120,
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 900 },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "部別",
        dataIndex: "Division",
        align: "center",
        width: 60,
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 900 },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "總人數",
        dataIndex: "TotalCount",
        align: "center",
        width: 40,
        render(text, record) {
        
          return {
            props: {
              style: { fontWeight: 900 },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "就業人數",
        dataIndex: "WorkCount",
        align: "center",
        width: 40,
        render(text, record) {
          return {
            props: {
              style: { fontWeight: 900 },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "百分比(%)",
        dataIndex: "Percentage",
        align: "center",
        width: 40,
        render(text, record) {
            var textColor = "#FF0000";
            if (text > 59) {
                textColor = "#006400";
            }
          return {
            props: {
              style: { fontWeight: 900, color: textColor, },
            },
            children: <div>{text}%</div>,
          };
        },
      },
    ];

    return (
      <>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <p></p>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(FreshWorkPercentage);
